import EventActionProto from '../event-action-proto'
import RequestForm from "../../../app/tools/request-forms2/model/request-form"
import {RequestFormType} from "../../../app/tools/request-forms2/const/const"

export default class SessionRequestFormNew extends EventActionProto {

    constructor(sessionEvent) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId)
        this.method     = sessionEvent.method
        this.header     = {
            requestForm : sessionEvent.data,
            isBulkUpdate: sessionEvent.isBulkUpdate,
        }
        this.fromSID    = sessionEvent.fromSID
    }

    process() {
        if (this.isDifferentCompany()) return false

        if (gd.session.requestFormsLoaded && this.data.type === RequestFormType.REQUEST)
            gd.session.requestForms.add(new RequestForm(this.data))

        gd.modelBus.newUpdate('request-form', this.method, this.header.requestForm.id, this.data, this.header)
    }
}
